import { createAction } from "@reduxjs/toolkit";
import * as ACTIONTYPES from "../action-types/catalog";
import { MPSellerSelectionData } from "@efood-commerce-sdk/typescript-axios-transaction-efood/dist/es/types/com/telekom-mms/efood/api/model";

export const CATEGORYVIEW_TOP_REQUEST_ACTION = createAction<any, string>(
  ACTIONTYPES.CATEGORYVIEW_TOP_REQUEST
);
export const CATEGORYVIEW_TOP_ERROR_ACTION = createAction<unknown, string>(
  ACTIONTYPES.CATEGORYVIEW_TOP_ERROR
);

export const FETCHING_SELLER_ACTION = createAction(
  ACTIONTYPES.SELLER_FETCHING_REQUESTED
);
export const FETCHING_SELLER_SUCCESS_ACTION = createAction<{
  seller: MPSellerSelectionData[];
}>(ACTIONTYPES.SELLER_GET_SUCCESS);

export const FETCHING_SELLER_ERROR_ACTION = createAction<unknown, string>(
  ACTIONTYPES.SELLER_GET_ERROR
);

export const SET_SELLER_CHOICE_ACTION = createAction<string, string>(
  ACTIONTYPES.SET_SELLER_CHOICE
);

export const CHECK_SELLER_CHOICE_EXPIRATION_ACTION = createAction(
  ACTIONTYPES.CHECK_SELLER_CHOICE_EXPIRATION
);

export const RESET_SELLER_CHOICE_ACTION = createAction(
  ACTIONTYPES.RESET_SELLER_CHOICE
);

export const setHasOfflineProducts = createAction<boolean>(
  ACTIONTYPES.SET_HAS_OFFLINE_PRODUCTS
);

export const setOfflineAvailableSellers = createAction<string[]>(
  ACTIONTYPES.SET_OFFLINE_AVAILABLE_SELLERS
);
